import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type ArrowUpIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const ArrowUpIcon = ({ strokeWidth, ...props }: ArrowUpIconProps) => (
  <BaseIcon width="14" height="18" viewBox="0 0 14 18" fill="none" strokeWidth={strokeWidth} {...props}>
    <g clipPath="url(#clip0_8335_35577)">
      <path
        d="M12.2929 7.70711C12.6834 8.09763 13.3166 8.09763 13.7071 7.70711C14.0976 7.31658 14.0976 6.68342 13.7071 6.29289L7.70711 0.292893C7.31658 -0.0976311 6.68342 -0.0976311 6.29289 0.292893L0.292893 6.29289C-0.0976309 6.68342 -0.097631 7.31658 0.292893 7.70711C0.683418 8.09763 1.31658 8.09763 1.70711 7.70711L6 3.41421L6 17C6 17.5523 6.44772 18 7 18C7.55229 18 8 17.5523 8 17L8 3.41421L12.2929 7.70711Z"
        fill="#141B4D"
      />
    </g>
    <defs>
      <clipPath id="clip0_8335_35577">
        <rect width="14" height="18" fill="white" />
      </clipPath>
    </defs>
  </BaseIcon>
);

ArrowUpIcon.displayName = 'ArrowUpIcon';
